/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';

var LOG = require('logger').getLogger('plate');

var $ = window.jQuery = require('base'), touchspin = $.Deferred();

var _super = require('../com.jufeng.product');
var p_league = $("#p_league").val();
var p_no = $("#p_no").val();
var initval = 1,min = 1,league ="hangzhouno009", lp_league ="langfang071" , wx_league ="wuxino051" , xa_league ="xian02" ;//="hangzhouno009";

if (league == p_league && '8090110030045' == p_no ) {
	initval = 30,min = 30;
}
require.ensure('bootstrap-touchspin', function () {
	require('bootstrap-touchspin');
	$('input[data-prop-path$="count"]').TouchSpin({
		initval: initval, // 初始值
		min: min,
		max: 99999,
		step: 1,
		verticalbuttons: true,
		verticalupclass: 'icon-starry-normal-plus4 j-a-btn-num-up',
		verticaldownclass: 'icon-starry-normal-minus5 j-a-btn-num-down'
	})
	touchspin.resolve();
});

$.when(_super.number_util, _super.model, touchspin).then(function (number_util, model_args) {
	var model_factory = model_args[0],
	cur_model = model_args[1];
	_super.seckill_deferred.done(function (product, sign) {
		if (product.handle == 0) {
			// 恢复订购数量
			$('input[data-prop-path$="width"],input[data-prop-path$="length"],input[data-prop-path$="count"]').removeAttr('disabled');
			// 恢复抢购按钮
			$('.buy_toolbar_box .btn_multi_right .cart_btn_big', '#product_main').removeClass('none');
		} else {
			var models = product.models;
			var sales_models = $.map(models, function (m, i) {
					var code = m.code, //
					el = $('input[value="' + code + '"]', '#product_main');
					if (m.stock <= 0) {
						el.parent().removeClass('active').addClass('disabled');
						el.attr('disabled', 'disabled');
						$('input[value="' + code + '"]', '#product_main').disable();
						return null;
					}
					return m;
				});
			if (sales_models.length > 0) { // 如果存在可销售的型号，则允许订购
				// 恢复订购数量
				$('input[data-prop-path$="width"],input[data-prop-path$="length"],input[data-prop-path$="count"]').removeAttr('disabled');
				// 恢复抢购按钮
				$('.buy_toolbar_box .btn_multi_right .cart_btn_big', '#product_main').removeClass('none');
			}
		}
	});
	_super.seckill_end_deferred.done(function (product, sign) {
		// 禁止订购数量
		$('input[data-prop-path$="width"],input[data-prop-path$="length"],input[data-prop-path$="count"]').attr('disabled', 'disabled');
		// 禁止抢购按钮
		$('.buy_toolbar_box .btn_multi_right .cart_btn_big', '#product_main').addClass('none');
	});
	function isEmptyObject(e) {  
	    var t;  
	    for (t in e)  
	        return !1;  
	    return !0  
	}  
	$('#spanAmountPrice').watching('cart_details.0.count pay_type cart_details.0.code', function (e, model) {
		var pay_type = model_factory.valOf(model, 'pay_type'),
		count = model_factory.valOf(model, 'cart_details.0.count'),
		code = model_factory.valOf(model, 'cart_details.0.code'),
		el_code = $('input[data-prop-path$=code][value="' + code + '"]'),
		prices = new Function("return " + el_code.data('prices'))();
		var pack = prices.p,
		price = prices[pay_type];
		var _count = 0;
		
		if (model.product_no == '8090110180001') {
			if (count >= 200 && count < 500){
				_count = 200;
			} else if(count >= 500) {
				_count = 500;
			}
		} else if (model.product_no == '8090110030045'){
			//浙江子公司规则
			if (league == p_league) {
				if (count >= 50 && count < 100){
					_count = 50;
				} else if(count >= 100) {
					_count = 100;
				}
			} else if (lp_league == p_league) {
				if(count >= 200) {
					_count = 200;
				}
			} else if (wx_league == p_league || xa_league == p_league) {
				if (count >= 50 && count < 100){
					_count = 50;
				} else if(count >= 100) {
					_count = 100;
				}
			} else {
				if (count >= 300 && count < 600){
					_count = 300;
				} else if (count >= 600 && count < 1000) {
					_count = 600;
				} else if(count >= 1000) {
					_count = 1000;
				}
			}
		}
		if (pay_type ==0 && _count > 0) {
			$.ajax({
				url : '/pro_common/getShare.htm?product_no='+ model.product_no,
				dataType : 'json',
				success: function(tip){
					var a = model.product_no+'-'+_count+'-'+code;
					if (isEmptyObject(tip)) {
						$('div.desc_price').find('.promo_price>dd>span:first').html(number_util.toFixed(price, 2));
						$("#pack_price").html(number_util.toFixed(price * pack, 2));
						$('#spanAmountPrice').html(number_util.toFixed(price * pack * count));
					} else {
						console.log(tip[a]);
						price = tip[a]*1;
						console.log(price);
						$('div.desc_price').find('.promo_price>dd>span:first').html(number_util.toFixed(price, 2));
						$("#pack_price").html(number_util.toFixed(price * pack, 2));
						$('#spanAmountPrice').html(number_util.toFixed(price * pack * count));
					}
				}
			})
		} else {
			$('div.desc_price').find('.promo_price>dd>span:first').html(number_util.toFixed(price, 2));
			$("#pack_price").html(number_util.toFixed(price * pack, 2));
			$(this).html(number_util.toFixed(price * pack * count));
		}
 	})
	$('div.desc_price').watching('cart_details.0.code pay_type', function (e, model) {
		var pay_type = model_factory.valOf(model, 'pay_type'),
		code = model_factory.valOf(model, 'cart_details.0.code'),
		el_code = $('input[data-prop-path$=code][value="' + code + '"]'),
		prices = new Function("return " + el_code.data('prices'))();
		var mkp = prices.mp,
		caption = (+pay_type) ? '账期价' : '现金价',
		price = prices[pay_type];

		$(this).find('.promo_price>dt').html(caption);
		$(this).find('.promo_price>dd>span:first').html(number_util.toFixed(price, 2));
		$(this).find('.org_price>dd').html('¥' + number_util.toFixed(mkp, 2));
		var pack_price = price * prices.p;
		$("#pack_price").html(number_util.toFixed(pack_price, 2));
		$("#pack_price_unit").html("元 /" + prices.u);
		$(".j_span_unit").html('元 /' + prices.pu);
	})

	// 触发事件.
	$('[data-prop-path="pay_type"]').trigger('change');

	_super.before_add2cart = $.proxy(function (model_factory, cur_model) {
			// 检测各属性
			var cart = cur_model();
			cart.price = +$('#spanAmountPrice').html();
			return cart;
		}, _super, model_factory, cur_model);

	//后台修改订单初始化
	_super.init_4_back_mdf_order();
})



// WEBPACK FOOTER //
// ./src/main/javascript/product/default/com.jufeng.default.js